import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DuitLebih } from 'src/model/duitLebih.model';

import { ReviewLoanRequestComponent } from 'src/app/LoanRequest/review-loan-request/review-loan-request.component';
import { Loan } from 'src/model/loan.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { SettlementCharges } from 'src/model/settlementCharges.model';
import { LoanService } from 'src/services/loan.service';
import { Enums } from '../../Shared/enums';
import { SharedService } from '../../Shared/shared-service.service';

@Component({
    selector: 'app-loan-request-message',
    templateUrl: './loan-request-message.component.html',
    styleUrls: ['./loan-request-message.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class LoanRequestMessageComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private activeModal = inject(NgbActiveModal);
  private datepipe = inject(DatePipe);
  private enums = inject(Enums);
  private loanService = inject(LoanService);

  @Input() requestList: LoanRequest[] = [];
  @Input() loanGroupId: number;
  // @Input() previousApprovedRequestList: LoanRequest[];
  @Input() isDirty = false;

  @Input() previousEPFLoanList: Loan[];
  @Input() isEPFRequest: boolean;

  settlement = 0;
  settlementWithCharges = 0;
  ratio = 0;
  value: string;
  @Input() compareString = "";

  previousSettlement = 0;
  previousSettlementRatio = 0;

  ngOnInit(): void {
    console.log(this.requestList);
    //sort request list by request ID
    this.requestList.sort((a, b) => ((a.ID > b.ID)) ? -1 : 1);

    //if epf request need to load all previous epf loan lists
    if (this.isEPFRequest == true) {
      if (this.previousEPFLoanList?.length > 0) {
        for (let i = 0; i < this.previousEPFLoanList.length; i++) {
          const termLeft = this.sharedService.roundTo2Dec(this.previousEPFLoanList[i].Balance / this.previousEPFLoanList[i].MonthlyPayment);

          if (this.previousEPFLoanList[i].Scheme == 'EPF') {
            const previousSettlementWithoutCharge = this.previousEPFLoanList[i].Principal + (this.previousEPFLoanList[i].Term *
              this.previousEPFLoanList[i].Principal * (this.previousEPFLoanList[i].InterestRate / 100));

            if (this.previousEPFLoanList[i].SettlementCharges == undefined)
              this.previousSettlement += previousSettlementWithoutCharge + this.previousEPFLoanList[i].SettlementExtra +
                this.previousEPFLoanList[i].SettlementServiceCharge + this.previousEPFLoanList[i].SettlementStamp;
            else
              this.previousSettlement += previousSettlementWithoutCharge + (this.previousEPFLoanList[i].SettlementCharges.Extras) +
                (this.previousEPFLoanList[i].SettlementCharges.ServiceCharge) + (this.previousEPFLoanList[i].SettlementCharges.Stamp);
          } else this.previousSettlement += this.previousEPFLoanList[i].LegacySettlement

          this.previousSettlementRatio = ((this.previousSettlement / this.requestList[0].EpfAmount) * 100);
        }

        this.constructEPFMessage();
      } else {
        this.getAllEPFLoans();
      }
    }

    //if normal loan straight construct message;
    else
      this.constructNormalLoanRequestMessage();
  }

  processDuitLebih() {
    let duitLebih = 0;
    this.requestList.forEach(request => {
      if (request.LoanInfo.Extras != undefined && request.LoanInfo.Extras.length > 0) {
        for (let i = 0; i < request.LoanInfo.Extras.length; i++) {
          duitLebih += request.LoanInfo.Extras[i].Amount;
        }
      }
    });

    return duitLebih;
  }

  constructNormalLoanRequestMessage() {
    const duitLebih = this.processDuitLebih();

    const str =
      "*COMPANY NAME: " + this.requestList[0].CompanyCode + "*\n" +
      "1) NAMA : " + this.requestList[0].CustomerName + "\n" +
      "2)  I/C : " + this.sharedService.processICNum(this.requestList[0].CustomerIC) + "\n" +
      "3) PROCESSING FEE : " + this.requestList[0].LoanInfo.ProcessingRate + "%\n" +
      "4) TEMPOH LOAN : " + this.requestList[0].LoanInfo.Term + " bulan (" + this.sharedService.roundTo2Dec(this.requestList[0].LoanInfo.InterestRate) + "%)\n" +
      "5) DUIT LEBIH : " + duitLebih + "\n" +
      "------------------------------------------------------\n\n" +
      "8) TOTAL LOAN : " + this.requestList[0].LoanInfo.Principal + "\n" +
      "9) SKIM: " + this.requestList[0].LoanInfo.Scheme + "\n" +
      "10) DPT TANGAN BERAPA : RM " + this.calculateTotalOnHand() + "\n" +
      "11) REMARK: " + this.requestList[0].Remark + "\n" +
      "------------------------------------------------------\n\n";
    this.value = "*Loan Request #" + this.requestList[0].ID + "*\n\n" + str;

  }

  processRemark() {
    let remark = "";
    this.requestList.forEach(request => {
      remark += request.Remark + "\n";
    });

    return remark;
  }

  combineAllRequestIds() {
    let ids = "";
    for (let i = 0; i < this.requestList.length; i++) {
      ids += "#" + this.requestList[i].ID;

      if (i != this.requestList.length - 1)
        ids += " | ";

    }

    return ids;
  }

  constructEPFMessage() {
    const duitLebih = this.processDuitLebih();
    const loanInfo = this.combineAllLoans();
    const remark = this.requestList[0].Remark;
    const requestIds = this.combineAllRequestIds();

    const iAccount = (this.requestList[0].HasIAccount == true) ? "YES" : "NO";

    let guarantorString = "";

    this.requestList[0].Guarantors.sort((a, b) => (a.Name > b.Name) ? 1 : -1);

    if (this.requestList[0].Guarantors.length > 0) {
      for (let i = 0; i < this.requestList[0].Guarantors.length; i++) {
        guarantorString +=
          "*GUARANTOR " + (i + 1) + "*\n" +
          "NAMA: " + this.requestList[0].Guarantors[i].Name + "\n" +
          "I/C: " + this.sharedService.processICNum(this.requestList[0].Guarantors[i].ICNumber) + "\n" +
          "Hubungan: " + this.requestList[0].Guarantors[i].Relation + "\n" +
          "---------------------------------------------------------\n";
      }
    }
    else
      guarantorString = "*NO GUARANTOR* \n" +
        "---------------------------------------------------------\n";

    let previousString = "";

    if (this.previousEPFLoanList.length > 0) {
      //List all previous loans
      for (let i = 0; i < this.previousEPFLoanList.length; i++) {
        let settlementString = "";
        if (this.previousEPFLoanList[i].Scheme == 'EPF') {
          settlementString = this.sharedService.roundTo2Dec(this.sharedService.calculateEPFSettlementAmountWithCharges(this.previousEPFLoanList[i])) + "\n"
        }
        else
          settlementString = this.previousEPFLoanList[i].LegacySettlement + "\n";

        const date = this.datepipe.transform(this.previousEPFLoanList[i].DateCreated, 'dd-MM-yyyy');
        previousString += date + " : RM" + this.sharedService.roundTo2Dec(this.previousEPFLoanList[i].Principal) + "➡️ RM" + settlementString

      }
    }

    let companyCodeStr = "";

    for (let i = 0; i < this.requestList.length; i++) {

      companyCodeStr += this.requestList[i].CompanyCode;
      if (i != this.requestList.length - 1)
        companyCodeStr += " | "

    }

    // customer info based on MAIN ticket / non shared ticket
    const mainRequest = this.requestList.find(r => (r.SharedProfileId == undefined || r.SharedProfileId == r.ProfileId));
    const str =
      "*COMPANY NAME: " + companyCodeStr + "*\n" +
      "1) NAMA : " + mainRequest.CustomerName + "\n" +
      "2)  I/C : " + this.sharedService.processICNum(mainRequest.CustomerIC) + "\n" +
      "3) DOB : " + this.datepipe.transform(mainRequest.DOB, "dd-MM-yyyy") + "\n" +
      "4) Other ID : " + (mainRequest.OtherId || "") + "\n" +
      "5) PROCESSING FEE : " + mainRequest.LoanInfo.ProcessingRate + "%\n" +
      "6) TEMPOH LOAN : " + mainRequest.LoanInfo.Term + " bulan (" + this.sharedService.roundTo2Dec(loanInfo.InterestRate) + "%)\n" +
      "7) DUIT LEBIH : " + this.sharedService.roundTo2Dec(duitLebih) + "\n" +
      "8) AMOUNT EPF : RM" + this.sharedService.roundTo2Dec(mainRequest.EpfAmount) + "\n" +
      "9) I-ACCOUNT KWSP: " + iAccount + "\n" +
      "------------------------------------------------------\n\n";

    let settlementStampString;
    let settlementSCString;
    let settlementDLString;
    let settlementHandlingChargeString;
    let individualLoanInfo = "";
    this.requestList.forEach(request => {

      if (request.LoanInfo.HasSettlementChargesObj ?? (request.LoanInfo.SettlementCharges !== undefined)) {
        settlementStampString = this.sharedService.roundTo2Dec(request.LoanInfo.SettlementCharges.Stamp / request.LoanInfo.Term) + "x" + request.LoanInfo.Term + "=RM " + request.LoanInfo.SettlementCharges.Stamp;
        settlementSCString = this.sharedService.roundTo2Dec(request.LoanInfo.SettlementCharges.ServiceCharge / request.LoanInfo.Term) + "x" + request.LoanInfo.Term + "=RM " + request.LoanInfo.SettlementCharges.ServiceCharge;
        settlementDLString = (request.LoanInfo.SettlementCharges.Extras == undefined) ? "0" : this.sharedService.roundTo2Dec(request.LoanInfo.SettlementCharges.Extras / request.LoanInfo.Term) + "x" + request.LoanInfo.Term + "=RM " + request.LoanInfo.SettlementCharges.Extras;
        settlementHandlingChargeString = (request.LoanInfo.SettlementCharges.HandlingCharge == undefined) ? "" : "- HANDLING CHARGE :  RM" + this.sharedService.roundTo2Dec(request.LoanInfo.SettlementCharges.HandlingCharge);
      } else {
        settlementStampString = request.LoanInfo.SettlementStamp;
        settlementSCString = request.LoanInfo.SettlementServiceCharge
        settlementDLString = request.LoanInfo.SettlementExtra
      }

      const mainCompanyIcon = (request.SharedProfileId == request.ProfileId && request.SharedProfileId != undefined)
        ? "*COMPANY:" + request.CompanyCode + " 🤝*\n"
        : "*COMPANY:" + request.CompanyCode + "*\n";

      individualLoanInfo +=
        mainCompanyIcon +
        "PRINCIPAL: " + request.LoanInfo.Principal + "\n" +
        "DPT TANGAN BERAPA : RM " + this.sharedService.roundTo2Dec(this.sharedService.calculateTotalOnHand(request.LoanInfo)) + "\n" +
        "*BAYAR BALIK  :RM " + this.sharedService.roundTo2Dec(this.sharedService.calculateEPFSettlementAmount(request.LoanInfo.Principal, request.LoanInfo.InterestRate, request.LoanInfo.Term)) + "*\n\n" +
        " SETTLEMENT CHARGES : \n" +
        "- SETTLEMENT STAMP : RM" + settlementStampString + " \n" +
        "- SETTLEMENT SC :  RM" + settlementSCString + " \n" +
        "- SETTLEMENT DL :  RM" + settlementDLString + " \n" +
        settlementHandlingChargeString + " \n\n" +
        "===================================\n\n";
    });

    const settlementWithCharges = this.sharedService.calculateEPFSettlementAmountWithCharges(loanInfo);
    const previousLoanSettlement = this.sharedService.calculatePreviousEPFLoanSettlement(this.previousEPFLoanList);

    const ratio = this.sharedService.calculateSettlementRatio(settlementWithCharges, this.requestList[0].EpfAmount);
    const previousLoanRatio = this.sharedService.calculateSettlementRatio(previousLoanSettlement, this.requestList[0].EpfAmount);

    const totalSummary =
      "*10) TOTAL LOAN : " + this.sharedService.roundTo2Dec(loanInfo.Principal) + "*\n" +
      "*11) TOTAL ON HAND : " + this.sharedService.roundTo2Dec(this.calculateTotalOnHand()) + "*\n" +
      "*12) ADDED SETTLEMENT (+CHARGES): RM" + this.sharedService.roundTo2Dec(settlementWithCharges) + "*\n" +
      "13) ADDED SETTLEMENT RATIO: " + ratio + "%\n" +
      "*14) TOTAL SETTLEMENT (+CHARGES): RM" + this.sharedService.roundTo2Dec(previousLoanSettlement + settlementWithCharges) + "*\n" +
      "*15) TOTAL SETTLEMENT RATIO: " + this.sharedService.roundTo2Dec(previousLoanRatio + ratio) + "%*\n" +
      "16) REMARK : " + (remark || "") + "\n" +
      "------------------------------------------------------\n\n" +
      "*GUARANTOR:*\n" + guarantorString + "\n"
    // +"VIEW MORE IN : https://" + window.location.host + "/manageCustomer/" + this.request.CustomerId + "/" + this.request.ProfileId

    if (this.previousEPFLoanList.length > 0) {

      if (this.loanGroupId != undefined && this.requestList.length > 1) {
        this.value = "*EXTRA SHARE ⓢ" + this.loanGroupId + " - TICKET " + requestIds + "*\n\n" + str + individualLoanInfo + totalSummary
          + "*PREVIOUS APPROVED LOANS:*\n" + previousString + "\n\n"

        "------------------------------------------------------\n";
      }
      else {
        this.value = "*EXTRA - TICKET " + requestIds + "*\n\n" + str + individualLoanInfo + totalSummary
          + "*PREVIOUS APPROVED LOANS:*\n" + previousString + "\n\n"

        "------------------------------------------------------\n";
      }

    }

    else {
      if (this.loanGroupId != undefined && this.requestList.length > 1)
        this.value = "*SHARE ⓢ" + this.loanGroupId + "- TICKET " + requestIds + "*\n\n" + str + individualLoanInfo + totalSummary;
      else
        this.value = "*TICKET " + requestIds + "*\n\n" + str + individualLoanInfo + totalSummary;
    }

  }

  combineAllLoans() {
    const loan: Loan = new Loan(0, 0, 0, 0, "", 0, new Date(), this.requestList[0].CompanyId, this.requestList[0].CompanyCode, this.requestList[0].LoanInfo.Scheme,
      0, this.requestList[0].LoanInfo.Term, undefined, undefined, undefined, 0, "", "", 0, 0, 0, 0, 0, 0);
    loan.Extras = [];
    loan.SettlementCharges = new SettlementCharges(0, 0, 0, 0);
    loan.SettlementExtra = 0;
    loan.SettlementServiceCharge = 0;
    loan.SettlementStamp = 0;

    this.requestList.forEach(request => {
      loan.Principal += request.LoanInfo.Principal;
      loan.Balance += request.LoanInfo.Balance;
      loan.InterestCharge += request.LoanInfo.InterestCharge;
      loan.Extras.concat(request.LoanInfo.Extras);
      loan.ServiceCharge += request.LoanInfo.ServiceCharge;
      loan.StampAmount += request.LoanInfo.StampAmount;
      loan.MonthlyPayment += this.sharedService.calculateMonthlyPayment(request.LoanInfo.InterestRate, request.LoanInfo.Principal, request.LoanInfo.Term)

      const requestSettlementInfo = (request.LoanInfo.SettlementCharges == undefined) ? new SettlementCharges(0, 0, 0, 0) : request.LoanInfo.SettlementCharges;
      loan.SettlementCharges.Stamp += requestSettlementInfo.Stamp || 0;
      loan.SettlementCharges.ServiceCharge += requestSettlementInfo.ServiceCharge || 0;
      loan.SettlementCharges.Extras += requestSettlementInfo.Extras || 0;
      loan.SettlementCharges.HandlingCharge += requestSettlementInfo.HandlingCharge || 0;

      loan.SettlementExtra += request.LoanInfo.SettlementExtra;
      loan.SettlementStamp += request.LoanInfo.SettlementStamp;
      loan.SettlementServiceCharge += request.LoanInfo.SettlementServiceCharge;

    });

    loan.InterestRate = this.sharedService.calculateInterestRate(loan.MonthlyPayment, loan.Principal, loan.Term);

    return loan;
  }

  async getAllEPFLoans() {
    this.previousEPFLoanList = [];
    const includedStatus = [this.enums.ACTIVE_LOAN, this.enums.WARNING_LOAN, this.enums.BAD_DEBT_LOAN];
    const profileId = this.requestList[0].SharedProfileId ||= this.requestList[0].ProfileId;
    const loan = await this.loanService.getLoanOfCustomerProfile(profileId, { schemes: ["EPF"], status: includedStatus, withLegacyEPF: false, includedSharedProfile: true });
    this.previousEPFLoanList = loan.filter(l => l.ID !== this.requestList[0].LoanID);
    this.constructEPFMessage();
  }

  processDuitLebihJsonArr(jsonArray: any) {
    const duitLebihList: DuitLebih[] = [];
    jsonArray.forEach(json => {
      const extra = new DuitLebih(json.amount, json.subtype)
      duitLebihList.push(extra);
    });

    return duitLebihList;
  }

  calculateTotalOnHand() {
    let total = 0;

    this.requestList.forEach(request => {
      let duitLebihTotal = 0;
      if (request.LoanInfo.Extras != undefined && request.LoanInfo.Extras.length > 0) {

        for (let j = 0; j < request.LoanInfo.Extras.length; j++)
          duitLebihTotal += request.LoanInfo.Extras[j].Amount;
      }

      const processingCharge = (request.LoanInfo.ProcessingRate / 100) * request.LoanInfo.Principal;
      const reserve = (request.LoanInfo.Reserve == undefined) ? 0 : request.LoanInfo.Reserve;

      total += request.LoanInfo.Principal - (reserve) - duitLebihTotal - processingCharge - request.LoanInfo.StampAmount -
        request.LoanInfo.ServiceCharge

    });

    return total;
  }

  reset() {

    if (this.isDirty == true)
      window.location.reload();
    else
      this.activeModal.close()

  }

  openReviewLoanRequestModal(request: Request) {
    const modalRef = this.sharedService.openModal(ReviewLoanRequestComponent, 'largeModal');
    modalRef.componentInstance.requestList = [request];
  }
}
